module.exports = __webpack_public_path__ + "static/img/openFlower4.a19b23f5.jpeg";